import { Box, Typography } from "@mui/material";
import { ReactComponent as CoinIcon } from "../../../Images/coin.svg";


export default function CreditsBadge({ credits = 0, dashboard }) {
  const n = Number(credits) || 0;
  const display = n.toFixed(2);

  return (
    <Box
      aria-label="total-credits"
      sx={{
        position: "absolute",
        top: 4,
        right: 12,
        zIndex: 60,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        background: "#F3E8FF",
        px: 2,
        py: 0.5,
        borderRadius: "28px",
        boxShadow: "none",
        minWidth: "fit-content",
      }}
    >
      <CoinIcon style={{ width: 15, height: 15, fill: "#fbc02d" }} />
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "12px",
          color: "#6a1b9a",
        }}
      >
        {display}
      </Typography>
      {/* <Chip
        label="Credits"
        size="small"
        sx={{
          background: "#E9DEF8",
          color: "#9c27b0",
          fontWeight: 600,
          fontSize: "11px",
          height: 22,
          borderRadius: "14px",
          border: "none",
          letterSpacing: 0.5,
        }}
      /> */}
      {n <= 0 && dashboard && (
        <a
          href={dashboard}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", marginLeft: 8 }}
        >
          <button
            style={{
              background: "#fff",
              color: "#5a3e91",
              border: "1px solid #e0e0e0",
              borderRadius: "16px",
              padding: "2px 12px",
              fontWeight: 600,
              fontSize: "12px",
              marginLeft: 2,
              cursor: "pointer",
              boxShadow: "0 1px 4px rgba(90,62,145,0.07)",
              transition: "background 0.2s, color 0.2s",
            }}
          >
            Buy More Credits
          </button>
        </a>
      )}
    </Box>
  );
}
